import React from 'react';

import { OrganizationAdminTabs } from './organization-admin-tabs';

type OrganizationAdminTab = 'progress' | 'response-data';

interface OrganizationAdminHeaderProps {
  activeTab: OrganizationAdminTab;
  organizationName: string;
}

export const OrganizationAdminHeader: React.FC<OrganizationAdminHeaderProps> = ({
  activeTab,
  organizationName,
}) => (
  <header className="mb-8 space-y-6">
    <div className="max-w-3xl">
      <p className="text-sm font-semibold uppercase tracking-[0.2em] text-muted-foreground">
        {organizationName}
      </p>
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-foreground sm:text-5xl">
        My Organization
      </h1>
      <p className="mt-3 text-base leading-7 text-muted-foreground">
        Review learning progress, user detail, and response data in one admin workspace.
      </p>
    </div>
    <OrganizationAdminTabs activeTab={activeTab} />
  </header>
);
